import {
  AppstoreOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  BlockOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Row, Statistic } from "antd";
import React from "react";

function OverviewStats(props) {
  return (
    <>
      {/* <div className="text-base pri-font mb-3">Users</div> */}
      {/* <Card style={{ borderColor: "#e5e7eb", marginBottom: "24px" }}>
          <div className="text-center py-12">
            <div className="text-3xl text-gray-400">
              <WarningOutlined />
            </div>
            <div className="text-lg pri-font text-gray-400">Not available</div>
            <div className="mb-3 text-gray-400 text-sm">
              Add designations and positions
            </div>
            <Button type="dashed">Add</Button>
          </div>
        </Card> */}
      <Row gutter={12}>
        <Col span={12} lg={8}>
          <Card
            onClick={() => props.setPlan("Org")}
            style={{
              borderColor: props.plan === "Org" ? "green" : "#e5e7eb",
              borderWidth: props.plan === "Org" && "2px",
              marginBottom: "24px",
              cursor: "pointer",
            }}
          >
            <Statistic
              title="Org plans"
              value={40}
              prefix={<ArrowDownOutlined style={{ color: "red" }} />}
              suffix="% completed"
            />
          </Card>
        </Col>
        <Col span={12} lg={8}>
          <Card
            onClick={() => props.setPlan("Unit")}
            style={{
              borderColor: props.plan === "Unit" ? "green" : "#e5e7eb",
              borderWidth: props.plan === "Unit" && "2px",
              marginBottom: "24px",
              cursor: "pointer",
            }}
          >
            <Statistic
              title="Unit plans"
              value={60}
              prefix={<ArrowUpOutlined style={{ color: "green" }} />}
              suffix="% completed"
            />
          </Card>
        </Col>
        <Col span={12} lg={8}>
          <Card
            onClick={() => props.setPlan("Your")}
            style={{
              borderColor: props.plan === "Your" ? "green" : "#e5e7eb",
              borderWidth: props.plan === "Your" && "2px",
              marginBottom: "24px",
              cursor: "pointer",
            }}
          >
            <Statistic
              title="Your plans"
              value={75}
              prefix={<ArrowUpOutlined style={{ color: "green" }} />}
              suffix="% completed"
            />
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default OverviewStats;
